import $i18n from '@alife/panda-i18n';
import React, { useRef, useState } from 'react';
import classnames from 'classnames';
import { CnButton, CnDialog, Form, Field, CnInput, CnMessage, CnBalloon, } from '@alife/cn-ui';
import { domain } from './utils';
import { componentName } from './const';
import './index.scss';
const FormItem = Form.Item;
const formItemLayout = {
    wrapperCol: {
        span: 24,
    },
};
function ExportNew(props) {
    const { selectedRowRecords = [], selectedRowKeys, _bindFilterData, params, className, popupClassName, children, footerActions = ['cancel', 'ok'], taskCenterUrl = 'https://data-wms.cainiao.com/main.html#/page/zreport/exportlist', customExportFn, progressData, preCheck, csrfToken, isNeedCsrf, isJump2History, primaryKey = '', exportUrl = `${domain.getDomain('data')}/api/zreport/user/exportdata`, requestOptions, csrfUrl, tip, isMenuItem = false, paramsJsx, _state, size = 'small', isNeedDataWrapper = true, } = props;
    const name = children || props.name || $i18n.get({ id: 'Export', dm: '导出' });
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const csrfId = useRef(null);
    const field = Field.useField();
    const getCsrf = () => {
        if (csrfId.current) {
            return Promise.resolve();
        }
        if (csrfToken) {
            csrfId.current = csrfToken;
            return Promise.resolve();
        }
        let tmpCsrfUrl = csrfUrl || `${domain.getDomain('data')}/api/csrf`;
        if (exportUrl) {
            if (exportUrl.indexOf('//') === 0) {
                try {
                    const tmpUrl = new URL(`https:${exportUrl}`);
                    tmpCsrfUrl = `${tmpUrl.origin}/api/csrf`;
                }
                catch (e) {
                    //
                }
            }
            else if (exportUrl.indexOf('http') === 0) {
                try {
                    const tmpUrl = new URL(exportUrl);
                    tmpCsrfUrl = `${tmpUrl.origin}/api/csrf`;
                }
                catch (e) {
                    //
                }
            }
            else if (exportUrl.indexOf('/') === 0) {
                tmpCsrfUrl = '/api/csrf';
            }
        }
        return fetch(tmpCsrfUrl, {
            mode: 'cors',
            credentials: 'include',
        })
            .then((data) => data.json())
            .then((res) => {
            if (res?.success) {
                if (res?.data?.token) {
                    csrfId.current = res?.data?.token;
                    return Promise.resolve();
                }
                return Promise.reject();
            }
            CnMessage.show({
                type: 'error',
                content: res?.error?.message,
            });
            return Promise.reject();
        })
            .catch((error) => {
            let errorMessage = '';
            if (error.response) {
                errorMessage = $i18n.get({
                    id: 'SystemExceptionErrorResponseStatuserrorresponsestatitext',
                    dm: '系统异常 {errorResponseStatus} - {errorResponseStatusText}',
                }, {
                    errorResponseStatus: error.response.status,
                    errorResponseStatusText: error.response.statusText,
                });
            }
            else {
                errorMessage =
                    error.message ||
                        $i18n.get({ id: 'NetworkAnomaly', dm: '网络异常' });
            }
            CnMessage.error(errorMessage);
            return Promise.reject();
        });
    };
    const handleExport = () => {
        if (preCheck && !preCheck()) {
            return;
        }
        setVisible(true);
    };
    const getSelectedKeys = (recordKey, records) => {
        const selectedKeys = [];
        records.forEach((n) => {
            selectedKeys.push(n[recordKey]);
        });
        return selectedKeys;
    };
    const onOk = () => {
        const queryParams = {};
        let param = {};
        field.validate((error, values) => {
            if (error) {
                return;
            }
            setLoading(true);
            const { taskName } = values;
            if (customExportFn) {
                customExportFn(taskName, taskCenterUrl)
                    .then(() => {
                    setLoading(false);
                    setVisible(false);
                })
                    .catch(() => setLoading(false));
                return;
            }
            if (Array.isArray(selectedRowKeys) && selectedRowKeys.length) {
                selectedRowKeys.forEach(() => {
                    queryParams[primaryKey] = getSelectedKeys(primaryKey, selectedRowRecords);
                });
            }
            Object.assign(queryParams, _bindFilterData);
            if (paramsJsx && typeof paramsJsx === 'function') {
                Object.assign(param, paramsJsx(_state));
            }
            else if (params && typeof params === 'object') {
                Object.assign(param, params);
            }
            param.exportName = taskName;
            if (progressData) {
                param = progressData(param, queryParams, paramsJsx ? paramsJsx?.(_state) : params, selectedRowRecords);
            }
            else {
                // 兼容老大宝逻辑
                param.type = params?.type === 'offline' ? 2 : 1;
                param.queryParams = queryParams;
            }
            Object.keys(param?.queryParams || {}).forEach((key) => {
                if (param?.queryParams && param?.queryParams?.[key] === '') {
                    delete param.queryParams[key];
                }
                if (param?.queryParams &&
                    typeof param?.queryParams?.[key] === 'undefined') {
                    delete param.queryParams[key];
                }
                if (param?.queryParams &&
                    Array.isArray(param?.queryParams?.[key]) &&
                    !param?.queryParams?.[key]?.length) {
                    delete param.queryParams[key];
                }
            });
            const doExport = () => {
                fetch(exportUrl, {
                    method: 'post',
                    body: isNeedDataWrapper
                        ? JSON.stringify({
                            data: param,
                            csrfId: csrfId.current,
                            _csrf: csrfId.current,
                        })
                        : JSON.stringify(param),
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'content-Type': 'application/json',
                    },
                    ...requestOptions,
                })
                    .then((res) => res.json())
                    .then((res) => {
                    if (res?.success) {
                        setVisible(false);
                        CnMessage.show({
                            type: 'success',
                            duration: 5000,
                            content: (React.createElement("span", { className: 'task-center-notice' },
                                $i18n.get({
                                    id: 'TheTaskWasCreatedSuccessfullyClick_344111788',
                                    dm: '任务创建成功，点击到',
                                }),
                                React.createElement(CnButton, { text: true, component: 'a', href: taskCenterUrl, target: '_blank', type: 'primary' }, $i18n.get({ id: 'MissionCenter', dm: '任务中心' })),
                                $i18n.get({ id: 'View', dm: '查看' }))),
                        });
                    }
                    else {
                        CnMessage.show({
                            type: 'error',
                            content: res?.error?.message ||
                                $i18n.get({ id: 'ExportFailed', dm: '导出失败' }),
                        });
                    }
                    setLoading(false);
                })
                    .catch((err) => {
                    let errorMessage = '';
                    if (err?.response) {
                        errorMessage = $i18n.get({
                            id: 'SystemExceptionErrResponseStatuserrresponsestatitext',
                            dm: '系统异常 {errResponseStatus} - {errResponseStatusText}',
                        }, {
                            errResponseStatus: err.response.status,
                            errResponseStatusText: err.response.statusText,
                        });
                    }
                    else {
                        errorMessage =
                            err.message ||
                                $i18n.get({ id: 'NetworkAnomaly', dm: '网络异常' });
                    }
                    CnMessage.show({
                        type: 'error',
                        content: errorMessage,
                    });
                })
                    .finally(() => {
                    setLoading(false);
                });
            };
            if (!isNeedCsrf) {
                doExport();
                return;
            }
            getCsrf()
                .then(() => doExport())
                .catch(() => setLoading(false));
        });
    };
    const renderButtons = () => {
        if (isJump2History) {
            return (React.createElement("a", { href: taskCenterUrl, className: 'btn-task-center', target: '_blank', rel: 'noreferrer' }, $i18n.get({ id: 'MissionCenter', dm: '任务中心' })));
        }
        let content;
        if (!isMenuItem) {
            content = (React.createElement(CnButton, { onClick: () => handleExport(), size: size, "data-hottag-name": 'cn-sc-wms-biz-download' }, name));
        }
        else {
            content = (React.createElement("div", { onClick: () => handleExport(), "data-hottag-name": 'cn-sc-wms-biz-download' }, name));
        }
        return tip ? (React.createElement(CnBalloon, { trigger: content, triggerType: 'hover', closable: false }, tip)) : (content);
    };
    return (React.createElement("div", { style: { flexGrow: 1 } },
        React.createElement("div", { className: classnames('cn-sc-export', className) }, renderButtons()),
        React.createElement(CnDialog, { className: classnames('cn-sc-export-pop', popupClassName), visible: visible, onClose: () => setVisible(false), onCancel: () => setVisible(false), onOk: onOk, okProps: {
                loading,
            }, style: { width: 400 }, title: $i18n.get({ id: 'ExportFileNaming', dm: '导出文件命名' }), footerActions: footerActions },
            React.createElement(Form, { field: field, ...formItemLayout },
                React.createElement(FormItem, { hasFeedback: true, required: true, requiredMessage: $i18n.get({ id: 'Required', dm: '必填项' }) },
                    React.createElement(CnInput, { name: 'taskName', placeholder: $i18n.get({
                            id: 'gxms-pc_Enter.CNTM',
                            dm: '请输入',
                        }) }))))));
}
ExportNew.displayName = componentName;
export { ExportNew };
